import './_collection-title.scss';

export default () => {};
